module.exports = __webpack_public_path__ + "static/media/videoInactive.c6f2eda9.png";